import { render, staticRenderFns } from "./queTaskApply.vue?vue&type=template&id=021cca86&scoped=true&"
import script from "./queTaskApply.vue?vue&type=script&lang=js&"
export * from "./queTaskApply.vue?vue&type=script&lang=js&"
import style0 from "./queTaskApply.vue?vue&type=style&index=0&id=021cca86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021cca86",
  null
  
)

export default component.exports